import { render, staticRenderFns } from "./assignments-modal.vue?vue&type=template&id=335198f9&scoped=true&"
import script from "./assignments-modal.ts?vue&type=script&lang=ts&"
export * from "./assignments-modal.ts?vue&type=script&lang=ts&"
import style0 from "./assignments-modal.scss?vue&type=style&index=0&id=335198f9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335198f9",
  null
  
)

export default component.exports